import {InputText} from '@/components/commons/input-text/InputText'
import styled from 'styled-components'

export const StyledUppercaseTextInput = styled(InputText)`
    & input {
        text-transform: uppercase;
    }
`
